// extracted by mini-css-extract-plugin
module.exports = {"root":"PhoneUs_root__3sBm_","image":"PhoneUs_image__28-dE","title":"PhoneUs_title__k8A7J","text":"PhoneUs_text__2z63h","number":"PhoneUs_number__31-Pt"};